import { useState } from "react";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";

const AddFeature = ({ setAddPakej }) => {
  const [formData, setFormData] = useState({
    pakej: "",
    sale_price: "",
    normal_price: "",
    product_id: "",
    tema: 0,
    music: 0,
    contacts: 0,
    direction: 0,
    countdown: 0,
    rsvp: 0,
    money_gift: 0,
    guestbook: 0,
    galleries: 0,
    pdf: 0,
  });

  // Handle text input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: ["sale_price", "normal_price", "product_id"].includes(name)
        ? parseFloat(value) || ""
        : value,
    }));
  };

  // Handle toggle change
  const handleToggle = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field] === 1 ? 0 : 1,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/features`, formData);
      alert("Pakej added successfully!");
      setAddPakej(false); // Close form after success
    } catch (error) {
      console.error("Error adding pakej:", error);
      alert("Failed to add pakej.");
    }
  };

  return (
    <div>
      <div className="flex items-center">
        <button onClick={() => setAddPakej(false)}>
          <FaAngleLeft className="text-4xl mr-4" />
        </button>
        <h1 className="text-3xl font-bold mb-4">Add Pakej</h1>
      </div>
      <form onSubmit={handleSubmit} className="max-w-3xl">
        {/* Text Fields */}
        {[
          { label: "Plan", name: "pakej", type: "text", placeholder: "Enter plan name" },
          { label: "Sale Price", name: "sale_price", type: "number", placeholder: "Enter sale price" },
          { label: "Normal Price", name: "normal_price", type: "number", placeholder: "Enter normal price" },
          { label: "Woocommerce Product ID", name: "product_id", type: "number", placeholder: "Enter woocommerce product id" },
        ].map(({ label, name, type, placeholder }) => (
          <div key={name} className="mb-4">
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <input
              type={type}
              name={name}
              value={formData[name]}
              placeholder={placeholder}
              onChange={handleChange}
              className="mt-1 p-2 w-full border rounded-md"
              required
            />
          </div>
        ))}

        {/* Toggle Buttons */}
        {[
          "tema",
          "music",
          "contacts",
          "direction",
          "countdown",
          "rsvp",
          "money_gift",
          "guestbook",
          "galleries",
          "pdf",
        ].map((field) => (
          <div key={field} className="flex justify-between items-center p-2 border rounded-md">
            <span className="capitalize">{field.replace("_", " ")}</span>
            <button
              type="button"
              onClick={() => handleToggle(field)}
              className={`w-12 h-6 flex items-center rounded-full p-1 transition ${
                formData[field] === 1 ? "bg-green-500" : "bg-gray-300"
              }`}
            >
              <div
                className={`w-5 h-5 bg-white rounded-full shadow-md transform transition ${
                  formData[field] === 1 ? "translate-x-6" : ""
                }`}
              ></div>
            </button>
          </div>
        ))}

        <button
          type="submit"
          className="w-full bg-button1 text-b1Text mt-4 py-2 rounded-lg hover:bg-button1Hover transition"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default AddFeature;
